const buttonTableActions = {
  text: 'filters'
};

export default buttonTableActions;
